import SEO from "../components/SEO";

export default function Academics() {
    return (
      <div className="container section">
        {/* SEO */}
        <SEO
          title="Academics | Sri Venkateswara Degree & PG College, Nellore"
          description="Explore Intermediate, Undergraduate, and Postgraduate programs, departments, and academic regulations at Sri Venkateswara College, Nellore."
        />
        <h2 className="text-3xl md:text-4xl font-semibold text-neutral-900">Academics</h2>

        <section className="mt-8">
          <h3 className="text-2xl font-semibold text-neutral-900">Departments</h3>
          <p className="mt-3 text-neutral-700">Computer Science, Management, Commerce, Mathematics, Statistics, English, Telugu, Sanskrit</p>
        </section>

        <section className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="card p-6">
            <h4 className="text-xl font-semibold text-neutral-900">Undergraduate</h4>
            <p className="mt-2 text-neutral-700">B.Sc (CS), B.Sc (AI), B.Com (CA), BA (PS), BCA (AI/CS/BIG DATA/Cloud/DS), BBA (Tourism/Business Analytics/General)</p>
          </div>
          <div className="card p-6">
            <h4 className="text-xl font-semibold text-neutral-900">Postgraduate</h4>
            <p className="mt-2 text-neutral-700">M.Sc (Computer Science), M.Com (General)</p>
          </div>
        </section>

        <section className="mt-12">
          <h3 className="text-2xl font-semibold text-neutral-900">Academic Regulations</h3>
          <div className="mt-4 grid md:grid-cols-2 gap-6">
            <div className="card p-6">
              <h5 className="font-semibold text-neutral-900">1. Legal & Regulatory Framework</h5>
              <p className="mt-2 text-neutral-700">Andhra Pradesh Educational Institutions Rules, 1987 and subsequent orders. UG & PG by affiliating university and APSCHE guidelines.</p>
            </div>
            <div className="card p-6">
              <h5 className="font-semibold text-neutral-900">2. Admission & Eligibility</h5>
              <ul className="mt-2 list-disc ml-5 text-neutral-700 space-y-1">
                <li>Undergraduate: OAMDC/APSCHE or university process; eligibility 10+2.</li>
                <li>Postgraduate: Relevant bachelor's degree; some courses via PGCETs.</li>
              </ul>
            </div>
            <div className="card p-6">
              <h5 className="font-semibold text-neutral-900">3. Attendance & Examination Eligibility</h5>
              <p className="mt-2 text-neutral-700">Minimum 75% attendance with condonation up to 15% in valid cases. Academic calendars issued yearly.</p>
            </div>
            <div className="card p-6">
              <h5 className="font-semibold text-neutral-900">4. Grading, Credits & Classifications</h5>
              <p className="mt-2 text-neutral-700">CBCS with semester pattern. Internal + end-semester determine final grades. Results classified based on GPA/OGPA.</p>
            </div>
            <div className="card p-6">
              <h5 className="font-semibold text-neutral-900">5. Evaluation Components</h5>
              <p className="mt-2 text-neutral-700">Internal assessment includes mid-tests, assignments, attendance. External exams conducted by boards/universities. Practical work, projects, dissertations integral.</p>
            </div>
            <div className="card p-6">
              <h5 className="font-semibold text-neutral-900">6. Reservation & Fees</h5>
              <p className="mt-2 text-neutral-700">State reservation policy applies (SC/ST/BC/PH/Ex-Servicemen etc.) with local area quota rules. Fee structures regulated by government/committees.</p>
            </div>
            <div className="card p-6 md:col-span-2">
              <h5 className="font-semibold text-neutral-900">7. Updates & Notifications</h5>
              <p className="mt-2 text-neutral-700">Universities issue yearly notifications for syllabi, examinations, and regulations. Institutions should monitor official circulars for compliance.</p>
            </div>
          </div>
        </section>
      </div>
    );
  }
  